"use strict";

var $ = require("jquery");
const Cookies = require('js-cookie');

$(document).ready(function () {

    let products = $('ul.products');
    let product = $('ul.products li.product');
    let iconGrid = $('.icon-grid');
    let iconList = $('.icon-list');
    let beforeShopLoop = $('.before-shop-loop');
    let layout = Cookies.get('product_layout');
    let loading = $('.products-loading');

    function cloneProductLabels() {
        product.each(function () {
            let productLabels = $(this).find('.custom-product-labels');
            let productBottom = $(this).find('.product-bottom');
            productBottom.append(productLabels.clone());
        })
    }
    function gridActive() {
        iconList.removeClass('active');
        iconGrid.addClass('active');
        beforeShopLoop.removeClass('list');
        beforeShopLoop.addClass('grid');
    }
    function listActive() {
        iconGrid.removeClass('active');
        iconList.addClass('active');
        beforeShopLoop.removeClass('grid');
        beforeShopLoop.addClass('list');
    }

    cloneProductLabels();

    if (layout && layout == 'grid') {
        gridActive();
    }
    if (layout && layout == 'list') {
        listActive();
    }

    products.css({ 'display': 'flex' });

    iconGrid.on('click', function () {
        gridActive();
        Cookies.set('product_layout', 'grid');
    });
    iconList.on('click', function () {
        listActive();
        Cookies.set('product_layout', 'list');
    });

    loading.hide();
});